import { checkValidEmail, checkValidPhone, checkOnlyText, checkHasMoreThanTwoCharacters } from '../common/Utilities'

const OBLIGATORY_FIELD = 'Este dato es obligatorio.'
const ONLY_CHAR_FIELD = 'Solo se permiten letras.'

const TELEFONO = 'Teléfono'
const CUIT_CUIL = 'CUIT/CUIL'
const DNI = 'DNI'
const CODIGO_POSTAL = 'Código postal'

const IS_MAX = true

const TELEPHONE_MAX_LENGTH = 12
const TELEPHONE_MIN_LENGTH = 10
const DNI_LENGTH = 8
const CUIT_CUIL_LENGTH = 11
const POSTAL_CODE_MAX_LENGTH = 8
const POSTAL_CODE_MIN_LENGTH = 4
const GENERIC_MIN_LENGTH = 3

const lengthErrorText = (field, value, isMax) => {
  return `${field} debe tener un ${isMax ? 'máximo' : 'mínimo'} de ${value} caracteres.`
}

const genericLengthErrorText = (value) => {
  return `Debe tener un mínimo de ${value} caracteres.`
}

const exactLengthErrorText = (field, value) => {
  return `${field} debe tener ${value} caracteres.`
}

const onlyNumberErrorText = (field) => {
  return `${field} solo permite números.`
}

export const validatePhone = (phone, options = {}) => {
  const maxLength = options.maxLength || TELEPHONE_MAX_LENGTH
  let errorItem
  if(!phone){
    errorItem = { error: true, message: OBLIGATORY_FIELD }
  } else if (!checkValidPhone(phone)) {
    errorItem = {
      error: true,
      message: 'Teléfono solo permite números y no debe iniciar con 0.'
    }
  } else if (options.skipMaxLength !== true && phone.length > maxLength) {
    errorItem = {
      error: true,
      message: lengthErrorText(TELEFONO, maxLength, IS_MAX)
    }
  } else if (options.skipMinLength !== true && phone.length < TELEPHONE_MIN_LENGTH) {
    errorItem = {
      error: true,
      message: exactLengthErrorText(TELEFONO, TELEPHONE_MIN_LENGTH)
    }
  } else {
      errorItem = { error: false, message: '' }
  }

    return errorItem
}

export const validateEmail = (email) => {
  let errorItem
  if(!email){
    errorItem = { error: true, message: OBLIGATORY_FIELD }
  } else if (!checkValidEmail(email)) {
    errorItem = {
      error: true,
      message: 'Ingrese un email válido.'
    }
  } else {
    errorItem = { error: false, message: '' }
  }

  return errorItem
}

export const validateDocument = (document) => {
  let errorItem
  if (document && isNaN(document)) {
    errorItem = {
      error: true,
      message: onlyNumberErrorText(DNI)
    }
  } else if (document && document.length !== DNI_LENGTH) {
    errorItem = {
      error: true,
      message: exactLengthErrorText(DNI, DNI_LENGTH)
    }
  }
  return errorItem
}

export const validateCuilCuit = (cuil_cuit, noRequired, client_type) => {
  let errorItem
  const validateClientType = noRequired !== client_type

  if((!cuil_cuit) && validateClientType) {
    errorItem = { error: true, message: OBLIGATORY_FIELD }
  } else if (cuil_cuit && isNaN(cuil_cuit)) {
    errorItem = {
      error: true,
      message: onlyNumberErrorText(CUIT_CUIL)
    }
  } else if (cuil_cuit && cuil_cuit.length !== CUIT_CUIL_LENGTH) {
    errorItem = {
      error: true,
      message: exactLengthErrorText(CUIT_CUIL, CUIT_CUIL_LENGTH)
    }
  } else {
    errorItem = { error: false, message: '' }

  }

  return errorItem
}

export const validateZipCode = (zip_code, noRequired) => {
  let errorItem

  if(!zip_code && !noRequired?.noValidate) {
    errorItem = { error: true, message: OBLIGATORY_FIELD }
  } else if (zip_code && zip_code.length > POSTAL_CODE_MAX_LENGTH) {
    errorItem = {
      error: true,
      message: lengthErrorText(CODIGO_POSTAL, POSTAL_CODE_MAX_LENGTH, IS_MAX)
    }
  
  } else if (zip_code && zip_code.length < POSTAL_CODE_MIN_LENGTH) {
    errorItem = {
      error: true,
      message: lengthErrorText(CODIGO_POSTAL, POSTAL_CODE_MIN_LENGTH, !IS_MAX)
    }
  }
  else {
    errorItem = { error: false, message: '' }
  }

  return errorItem
}

export const validateIsRequired = (field, noRequired) => {
  let errorItem
  if(!field && !noRequired?.noValidate) {
    errorItem = { error: true, message: OBLIGATORY_FIELD }
  }
  else {
    errorItem = { error: false, message: '' }
  }
  
  return errorItem
}

export const validateInputText = (value) => {
  let errorItem
  if(!value) {
    errorItem = { error: true, message: OBLIGATORY_FIELD }
  } else if(!checkOnlyText(value)) {
    errorItem = { error: true, message: ONLY_CHAR_FIELD }
  }else if(!checkHasMoreThanTwoCharacters(value)){
    errorItem = {error: true, message: genericLengthErrorText(GENERIC_MIN_LENGTH)}
  } else {
    errorItem = { error: false, message: '' }
  }
  return errorItem
}

export const validateBusinessName = (field) =>{
  let errorItem
  if(!field) {
    errorItem = {error: true, message: OBLIGATORY_FIELD}
  } else if (!checkHasMoreThanTwoCharacters(field)) {
    errorItem = {error: true, message: genericLengthErrorText(GENERIC_MIN_LENGTH)}
  }
  return errorItem
}